import { render, staticRenderFns } from "./ModalAdminGdlsCode.vue?vue&type=template&id=78d5a67c&scoped=true&lang=pug&"
import script from "./ModalAdminGdlsCode.vue?vue&type=script&lang=ts&"
export * from "./ModalAdminGdlsCode.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAdminGdlsCode.vue?vue&type=style&index=0&id=78d5a67c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d5a67c",
  null
  
)

export default component.exports